export interface MembroEquipe {
  membroId: string
  funcao: string
}

export interface EscalaItem {
  id: string
  equipe: MembroEquipe[]
  data: string
  horario: string
  url?: string
  observacoes?: string
  recorrencia?: 'nenhuma' | 'primeiro-domingo' | 'segundo-domingo' | 'terceiro-domingo' | 'quarto-domingo' | 'ultimo-domingo'
}

export const mockEscalas: Record<string, EscalaItem[]> = {
  // Ministério de Louvor (ID: 1)
  '1': [
    {
      id: 'escala-louvor-1',
      equipe: [
        { membroId: '1', funcao: 'Vocal Principal' },
        { membroId: '2', funcao: 'Guitarra' },
        { membroId: '3', funcao: 'Teclado' },
        { membroId: '4', funcao: 'Bateria' },
        { membroId: '5', funcao: 'Técnico de Som' }
      ],
      data: '2024-12-01',
      horario: '18:30',
      url: 'https://drive.google.com/playlist-louvor-dezembro',
      observacoes: 'Ensaio extra na quinta-feira às 19h',
      recorrencia: 'primeiro-domingo'
    },
    {
      id: 'escala-louvor-2',
      equipe: [
        { membroId: '2', funcao: 'Vocal Principal' },
        { membroId: '6', funcao: 'Guitarra' },
        { membroId: '7', funcao: 'Baixo' },
        { membroId: '1', funcao: 'Back Vocal' },
        { membroId: '8', funcao: 'Técnico de Som' }
      ],
      data: '2024-12-08',
      horario: '18:30',
      url: 'https://drive.google.com/playlist-louvor-dezembro',
      observacoes: 'Culto especial de Natal - repertório temático',
      recorrencia: 'segundo-domingo'
    },
    {
      id: 'escala-louvor-3',
      equipe: [
        { membroId: '3', funcao: 'Vocal Principal' },
        { membroId: '1', funcao: 'Guitarra' },
        { membroId: '4', funcao: 'Teclado' },
        { membroId: '6', funcao: 'Back Vocal' },
        { membroId: '5', funcao: 'Técnico de Som' }
      ],
      data: '2024-12-15',
      horario: '18:30',
      observacoes: 'Apresentação especial do coral infantil',
      recorrencia: 'terceiro-domingo'
    },
    {
      id: 'escala-louvor-4',
      equipe: [
        { membroId: '1', funcao: 'Vocal Principal' },
        { membroId: '2', funcao: 'Guitarra' },
        { membroId: '3', funcao: 'Teclado' },
        { membroId: '7', funcao: 'Baixo' },
        { membroId: '4', funcao: 'Bateria' },
        { membroId: '8', funcao: 'Técnico de Som' }
      ],
      data: '2024-12-22',
      horario: '18:30',
      url: 'https://drive.google.com/cantata-natal-2024',
      observacoes: 'Cantata de Natal - equipe completa',
      recorrencia: 'quarto-domingo'
    }
  ],

  // Ministério de Jovens (ID: 2)
  '2': [
    {
      id: 'escala-jovens-1',
      equipe: [
        { membroId: '6', funcao: 'Coordenador' },
        { membroId: '7', funcao: 'Intercessão' },
        { membroId: '8', funcao: 'Recepção' },
        { membroId: '1', funcao: 'Dinâmicas' }
      ],
      data: '2024-12-07',
      horario: '19:00',
      url: 'https://docs.google.com/encontro-jovens-dezembro',
      observacoes: 'Tema: "Propósito em Cristo"',
      recorrencia: 'nenhuma'
    },
    {
      id: 'escala-jovens-2',
      equipe: [
        { membroId: '2', funcao: 'Coordenador' },
        { membroId: '6', funcao: 'Louvor' },
        { membroId: '3', funcao: 'Testemunho' },
        { membroId: '7', funcao: 'Apoio' }
      ],
      data: '2024-12-14',
      horario: '19:00',
      observacoes: 'Noite de testemunhos e oração',
      recorrencia: 'nenhuma'
    },
    {
      id: 'escala-jovens-3',
      equipe: [
        { membroId: '8', funcao: 'Coordenador' },
        { membroId: '1', funcao: 'Louvor' },
        { membroId: '4', funcao: 'Recepção' },
        { membroId: '5', funcao: 'Lanche' }
      ],
      data: '2024-12-21',
      horario: '19:00',
      url: 'https://drive.google.com/confraternizacao-jovens',
      observacoes: 'Confraternização de fim de ano',
      recorrencia: 'nenhuma'
    }
  ],

  // Ministério Infantil (ID: 3)
  '3': [
    {
      id: 'escala-infantil-1',
      equipe: [
        { membroId: '4', funcao: 'Professora Principal' },
        { membroId: '5', funcao: 'Auxiliar' },
        { membroId: '6', funcao: 'Recreação' },
        { membroId: '7', funcao: 'Lanche' }
      ],
      data: '2024-12-01',
      horario: '09:00',
      url: 'https://drive.google.com/licao-infantil-dezembro',
      observacoes: 'Lição: "O Nascimento de Jesus"',
      recorrencia: 'primeiro-domingo'
    },
    {
      id: 'escala-infantil-2',
      equipe: [
        { membroId: '3', funcao: 'Professora Principal' },
        { membroId: '8', funcao: 'Auxiliar' },
        { membroId: '1', funcao: 'Música' },
        { membroId: '2', funcao: 'Artesanato' }
      ],
      data: '2024-12-08',
      horario: '09:00',
      observacoes: 'Atividade especial: Presépio com as crianças',
      recorrencia: 'segundo-domingo'
    },
    {
      id: 'escala-infantil-3',
      equipe: [
        { membroId: '5', funcao: 'Professora Principal' },
        { membroId: '4', funcao: 'Auxiliar' },
        { membroId: '6', funcao: 'Teatro' },
        { membroId: '7', funcao: 'Apoio' }
      ],
      data: '2024-12-15',
      horario: '09:00',
      url: 'https://drive.google.com/teatro-natal-infantil',
      observacoes: 'Apresentação teatral: "A Estrela de Belém"',
      recorrencia: 'terceiro-domingo'
    },
    {
      id: 'escala-infantil-4',
      equipe: [
        { membroId: '8', funcao: 'Coordenadora' },
        { membroId: '3', funcao: 'Professora' },
        { membroId: '1', funcao: 'Música' },
        { membroId: '4', funcao: 'Recreação' },
        { membroId: '5', funcao: 'Lanche' }
      ],
      data: '2024-12-22',
      horario: '09:00',
      observacoes: 'Festa de Natal das crianças',
      recorrencia: 'quarto-domingo'
    }
  ],

  // Ministério de Intercessão (ID: 4)
  '4': [
    {
      id: 'escala-intercessao-1',
      equipe: [
        { membroId: '1', funcao: 'Líder de Oração' },
        { membroId: '3', funcao: 'Intercessor' },
        { membroId: '5', funcao: 'Intercessor' },
        { membroId: '7', funcao: 'Apoio' }
      ],
      data: '2024-12-03',
      horario: '06:00',
      observacoes: 'Vigília de oração - primeira terça do mês',
      recorrencia: 'nenhuma'
    },
    {
      id: 'escala-intercessao-2',
      equipe: [
        { membroId: '2', funcao: 'Líder de Oração' },
        { membroId: '4', funcao: 'Intercessor' },
        { membroId: '6', funcao: 'Intercessor' },
        { membroId: '8', funcao: 'Apoio' }
      ],
      data: '2024-12-10',
      horario: '06:00',
      observacoes: 'Oração pelos ministérios da igreja',
      recorrencia: 'nenhuma'
    },
    {
      id: 'escala-intercessao-3',
      equipe: [
        { membroId: '3', funcao: 'Líder de Oração' },
        { membroId: '1', funcao: 'Intercessor' },
        { membroId: '7', funcao: 'Intercessor' },
        { membroId: '5', funcao: 'Apoio' }
      ],
      data: '2024-12-17',
      horario: '06:00',
      observacoes: 'Oração pelas famílias da igreja',
      recorrencia: 'nenhuma'
    }
  ]
}

// Função helper para buscar escalas por ministério
export const getEscalasByMinisterio = (ministerioId: string): EscalaItem[] => {
  return mockEscalas[ministerioId] || []
}

// Função helper para buscar escala por ID
export const getEscalaById = (escalaId: string): EscalaItem | undefined => {
  for (const ministerioEscalas of Object.values(mockEscalas)) {
    const escala = ministerioEscalas.find(e => e.id === escalaId)
    if (escala) return escala
  }
  return undefined
}